import firebase from "firebase/compat/app";
import { DocumentData } from "firebase/firestore";

export default class RecoveryPasswordRepository {

  async findUser(email: string): Promise<DocumentData | null> {
    try {
      const firestore = firebase.firestore();
      const users = await firestore.collection('users').where('email', '==', email).get();
      const user = users.empty ? null : users.docs[0].data();
      return user;
    } catch (error) {
      throw error;
    }
  }
}